var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('bc-navbar-public'),_c('b-container',{staticClass:"content-spacer-lg"},[_c('alerts-panel'),_c('router-view')],1),_c('bc-footer-public')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }